import React, { type ReactElement, type ReactNode, useState } from 'react';

import classNames from 'classnames';

import {
	BUTTON_TYPES,
	EvButton,
	EvCheckbox,
	EvFlexRow,
	EvIcon,
	EvSection
} from '@evinced-private/ui-common';

import './ClarificationBanner.scss';

interface ClarificationBannerProps {
	children: ReactNode;
	toggleLabel?: string;
	dismissButtonText?: string;
	dismissIcon?: string;
	className?: string;
	showToggle?: boolean;
	hide: () => void;
	hidePermanently?: () => void;
}

export const ClarificationBanner = ({
	children,
	className,
	dismissIcon,
	hide,
	hidePermanently,
	dismissButtonText = 'Dismiss',
	toggleLabel = "Don't show again",
	showToggle = true
}: ClarificationBannerProps): ReactElement => {
	const [isChecked, setIsChecked] = useState(false);

	const toggleCheckbox = (): void => {
		setIsChecked((prevState) => !prevState);
	};

	const handleDismiss = (): void => {
		if (isChecked && hidePermanently) {
			hidePermanently();
		} else {
			hide();
		}
	};

	return (
		<EvSection className={classNames('clarification-banner', className)}>
			{children && (
				<EvFlexRow wrap="NOWRAP" flex="2">
					{children}
				</EvFlexRow>
			)}
			<EvFlexRow justify={children ? 'END' : 'START'} flex="1">
				{showToggle && hidePermanently && (
					<div className="never-show-checkbox">
						<EvCheckbox label={toggleLabel} onClick={toggleCheckbox} isChecked={isChecked} />
					</div>
				)}
				<EvButton onClick={handleDismiss} ariaLabel={dismissButtonText} type={BUTTON_TYPES.GHOST}>
					{dismissIcon ? <EvIcon icon={dismissIcon} small /> : dismissButtonText}
				</EvButton>
			</EvFlexRow>
		</EvSection>
	);
};
